/// <reference types="google.accounts" />
export const useGoogleSignIn = sharedComposable(() => {
  const {
    public: {
      scripts: {
        googleAuth: { clientId: clientId },
      },
    },
  } = useRuntimeConfig()

  const loginCallback = usePerformGoogleLogin()
  const user = useUserState()

  const script = useScript(
    {
      src: 'https://accounts.google.com/gsi/client',
      async: true,
      crossorigin: false,
    },
    {
      trigger: user.value ? 'manual' : undefined,
      warmupStrategy: user.value ? false : undefined,
    }
  )

  if (import.meta.client) {
    script.onLoaded(() => {
      google.accounts.id.initialize({
        client_id: clientId,
        callback: (credentialResponse) => loginCallback(credentialResponse.credential),
      })
      google.accounts.id.prompt()
    })
  }

  return script
})
